<template>
  <div class="contentbox">
    <div class="wbdp-long-tail">
      <div class="top-search">
        <el-form :inline="true" :model="formInline" ref="formInline" size="small" class="demo-form-inline select-nobg">
          <el-form-item label="充值时间：">
						<el-date-picker
							v-model="dataTime"
							class="pickerData"
							format="yyyy-MM-dd"
              value-format="yyyy-MM-dd"
              type="daterange"
							unlink-panels
							range-separator="至"
							start-placeholder="开始日期"
							end-placeholder="结束日期" style="margin-right: 10px; width: 400px" clearable @change="search">
						</el-date-picker>
					</el-form-item>
          <el-form-item>
            <el-button type="primary" icon="el-icon-search" @click="search">查询</el-button>
          </el-form-item>
          <el-form-item>
            <el-button icon="el-icon-refresh" @click="resetQuery">重置</el-button>
          </el-form-item>
        </el-form>
      </div>
      <div class="tableTh" v-height>
				<el-table :data="tableData.result" border stripe style="width: 100%" height="100%" class="tableStyle" v-loading="loading">
					<el-table-column prop="st_up_time_1" label="首次充值时间" width="120" fixed>
						<template slot="header">
              <el-tooltip class="item" effect="dark" content="用户第一次充值时间，或者老订阅用户取消后再此充值，都算首次" placement="top">
                <p>首次充值时间</p>
              </el-tooltip>
            </template>
						<template slot-scope="scope">
							<div class="td-info">
								<p>{{scope.row.st_up_time_1}}</p>
							</div>
						</template>
					</el-table-column>
					<el-table-column prop="pro_cost" label="推广费" width="100">
						<template slot="header">
              <el-tooltip class="item" effect="dark" content="按推广现金，手动填写" placement="top">
                <p>推广费</p>
              </el-tooltip>
            </template>
						<template slot-scope="scope">
							<div class="td-info">
								<p>{{scope.row.pro_cost}}</p>
							</div>
						</template>
					</el-table-column>
					<el-table-column prop="new_users" label="注册人数" width="100">
						<template slot="header">
              <el-tooltip class="item" effect="dark" content="按回传的数字，手动填写" placement="top">
                <p>注册人数</p>
              </el-tooltip>
            </template>
						<template slot-scope="scope">
							<div class="td-info">
								<p>{{scope.row.new_users}}</p>
							</div>
						</template>
					</el-table-column>
					<el-table-column prop="st_up_users_1" label="首日充值人数" width="120" >
						<template slot-scope="scope">
							<div class="td-info">
								<p>{{scope.row.st_up_users_1}}</p>
							</div>
						</template>
					</el-table-column>
					<el-table-column prop="st_sign_users_1" label="首日订阅人数" width="120" >
						<template slot="header">
              <el-tooltip class="item" effect="dark" content="只算订阅，订阅管理表" placement="top">
                <p>首日订阅人数</p>
              </el-tooltip>
            </template>
						<template slot-scope="scope">
							<div class="td-info">
								<p>{{scope.row.st_sign_users_1}}</p>
							</div>
						</template>
					</el-table-column>
					<el-table-column prop="st_up_money_1" label="首日充值金额" width="120">
						<template slot-scope="scope">
							<div class="td-info">
								<p>{{scope.row.st_up_money_1}}</p>
							</div>
						</template>
					</el-table-column>
					<el-table-column prop="st_sign_money_1" label="首日订阅金额" width="120">
						<template slot-scope="scope">
							<div class="td-info">
								<p>{{scope.row.st_sign_money_1}}</p>
							</div>
						</template>
					</el-table-column>
					<el-table-column prop="st_sign_rate_1" label="首充率" width="100">
            <template slot="header">
              <el-tooltip class="item" effect="dark" content="首日充值人数/导流次数" placement="top">
                <p>首充率</p>
              </el-tooltip>
            </template>
						<template slot-scope="scope">
							<div class="td-info">
								<p>{{scope.row.st_sign_rate_1}}</p>
							</div>
						</template>
					</el-table-column>
					<el-table-column prop="paid_cost" label="付费成本" width="100">
						<template slot="header">
              <el-tooltip class="item" effect="dark" content="推广费用/充值人数" placement="top">
                <p>付费成本</p>
              </el-tooltip>
            </template>
						<template slot-scope="scope">
							<div class="td-info">
								<p>{{scope.row.paid_cost}}</p>
							</div>
						</template>
					</el-table-column>
					<el-table-column prop="arppu" label="ARPPU" width="100">
						<template slot-scope="scope">
							<div class="td-info">
								<p>{{scope.row.arppu}}</p>
							</div>
						</template>
					</el-table-column>
					<el-table-column prop="st_again_sign_rate_1" label="首日包月续订率" width="150">
						<template slot-scope="scope">
							<div class="td-info">
								<p>{{scope.row.st_again_sign_rate_1}}</p>
							</div>
						</template>
					</el-table-column>
					<el-table-column prop="st_payback_rate_1" label="首日回本率" width="150">
						<template slot-scope="scope">
							<div class="td-info">
								<p>{{scope.row.st_payback_rate_1}}</p>
							</div>
						</template>
					</el-table-column>
					<el-table-column prop="st_sign_users_2" label="2月包月续订数" width="150">
						<template slot-scope="scope">
							<div class="td-info">
								<p>{{scope.row.st_sign_users_2}}</p>
							</div>
						</template>
					</el-table-column>
					<el-table-column prop="st_again_sign_money_2" label="2月包月续订金额" width="150">
						<template slot-scope="scope">
							<div class="td-info">
								<p>{{scope.row.st_again_sign_money_2}}</p>
							</div>
						</template>
					</el-table-column>
					<el-table-column prop="st_again_sign_rate_2" label="2月包月续订率" width="150">
						<template slot-scope="scope">
							<div class="td-info">
								<p>{{scope.row.st_again_sign_rate_2}}</p>
							</div>
						</template>
					</el-table-column>
					<el-table-column prop="st_payback_rate_2" label="2月累计回本率" width="150">
						<template slot-scope="scope">
							<div class="td-info">
								<p>{{scope.row.st_payback_rate_2}}</p>
							</div>
						</template>
					</el-table-column>
          <el-table-column prop="st_sign_users_3" label="3月包月续订数" width="150">
						<template slot-scope="scope">
							<div class="td-info">
								<p>{{scope.row.st_sign_users_3}}</p>
							</div>
						</template>
					</el-table-column>
					<el-table-column prop="st_again_sign_money_3" label="3月包月续订金额" width="150">
						<template slot-scope="scope">
							<div class="td-info">
								<p>{{scope.row.st_again_sign_money_3}}</p>
							</div>
						</template>
					</el-table-column>
					<el-table-column prop="st_again_sign_rate_3" label="3月包月续订率" width="150">
						<template slot-scope="scope">
							<div class="td-info">
								<p>{{scope.row.st_again_sign_rate_3}}</p>
							</div>
						</template>
					</el-table-column>
					<el-table-column prop="st_payback_rate_3" label="3月累计回本率" width="150">
						<template slot-scope="scope">
							<div class="td-info">
								<p>{{scope.row.st_payback_rate_3}}</p>
							</div>
						</template>
					</el-table-column>
          <el-table-column prop="st_sign_users_4" label="4月包月续订数" width="150">
						<template slot-scope="scope">
							<div class="td-info">
								<p>{{scope.row.st_sign_users_4}}</p>
							</div>
						</template>
					</el-table-column>
					<el-table-column prop="st_again_sign_money_4" label="4月包月续订金额" width="150">
						<template slot-scope="scope">
							<div class="td-info">
								<p>{{scope.row.st_again_sign_money_4}}</p>
							</div>
						</template>
					</el-table-column>
					<el-table-column prop="st_again_sign_rate_4" label="4月包月续订率" width="150">
						<template slot-scope="scope">
							<div class="td-info">
								<p>{{scope.row.st_again_sign_rate_4}}</p>
							</div>
						</template>
					</el-table-column>
					<el-table-column prop="st_payback_rate_4" label="4月累计回本率" width="150">
						<template slot-scope="scope">
							<div class="td-info">
								<p>{{scope.row.st_payback_rate_4}}</p>
							</div>
						</template>
					</el-table-column>
          <el-table-column prop="st_sign_users_5" label="5月包月续订数" width="150">
						<template slot-scope="scope">
							<div class="td-info">
								<p>{{scope.row.st_sign_users_5}}</p>
							</div>
						</template>
					</el-table-column>
					<el-table-column prop="st_again_sign_money_5	" label="5月包月续订金额" width="150">
						<template slot-scope="scope">
							<div class="td-info">
								<p>{{scope.row.st_again_sign_money_5	}}</p>
							</div>
						</template>
					</el-table-column>
					<el-table-column prop="st_again_sign_rate_5" label="5月包月续订率" width="150">
						<template slot-scope="scope">
							<div class="td-info">
								<p>{{scope.row.st_again_sign_rate_5}}</p>
							</div>
						</template>
					</el-table-column>
					<el-table-column prop="st_payback_rate_5" label="5月累计回本率" width="150">
						<template slot-scope="scope">
							<div class="td-info">
								<p>{{scope.row.st_payback_rate_5}}</p>
							</div>
						</template>
					</el-table-column>
          <el-table-column prop="st_sign_users_6" label="6月包月续订数" width="150">
						<template slot-scope="scope">
							<div class="td-info">
								<p>{{scope.row.st_sign_users_6}}</p>
							</div>
						</template>
					</el-table-column>
					<el-table-column prop="st_again_sign_money_6" label="6月包月续订金额" width="150">
						<template slot-scope="scope">
							<div class="td-info">
								<p>{{scope.row.st_again_sign_money_6}}</p>
							</div>
						</template>
					</el-table-column>
					<el-table-column prop="st_again_sign_rate_6" label="6月包月续订率" width="150">
						<template slot-scope="scope">
							<div class="td-info">
								<p>{{scope.row.st_again_sign_rate_6}}</p>
							</div>
						</template>
					</el-table-column>
					<el-table-column prop="st_payback_rate_6" label="6月累计回本率" width="150">
						<template slot-scope="scope">
							<div class="td-info">
								<p>{{scope.row.st_payback_rate_6}}</p>
							</div>
						</template>
					</el-table-column>
          <el-table-column prop="st_sign_users_7" label="7月包月续订数" width="150">
						<template slot-scope="scope">
							<div class="td-info">
								<p>{{scope.row.st_sign_users_7}}</p>
							</div>
						</template>
					</el-table-column>
					<el-table-column prop="st_again_sign_money_7" label="7月包月续订金额" width="150">
						<template slot-scope="scope">
							<div class="td-info">
								<p>{{scope.row.st_again_sign_money_7}}</p>
							</div>
						</template>
					</el-table-column>
					<el-table-column prop="st_again_sign_rate_7" label="7月包月续订率" width="150">
						<template slot-scope="scope">
							<div class="td-info">
								<p>{{scope.row.st_again_sign_rate_7}}</p>
							</div>
						</template>
					</el-table-column>
					<el-table-column prop="st_payback_rate_7" label="7月累计回本率" width="150">
						<template slot-scope="scope">
							<div class="td-info">
								<p>{{scope.row.st_payback_rate_7}}</p>
							</div>
						</template>
					</el-table-column>
          <el-table-column prop="st_sign_users_8" label="8月包月续订数" width="150">
						<template slot-scope="scope">
							<div class="td-info">
								<p>{{scope.row.st_sign_users_8}}</p>
							</div>
						</template>
					</el-table-column>
					<el-table-column prop="st_again_sign_money_8" label="8月包月续订金额" width="150">
						<template slot-scope="scope">
							<div class="td-info">
								<p>{{scope.row.st_again_sign_money_8}}</p>
							</div>
						</template>
					</el-table-column>
					<el-table-column prop="st_again_sign_rate_8" label="8月包月续订率" width="150">
						<template slot-scope="scope">
							<div class="td-info">
								<p>{{scope.row.st_again_sign_rate_8}}</p>
							</div>
						</template>
					</el-table-column>
					<el-table-column prop="st_payback_rate_8" label="8月累计回本率" width="150">
						<template slot-scope="scope">
							<div class="td-info">
								<p>{{scope.row.st_payback_rate_8}}</p>
							</div>
						</template>
					</el-table-column>
          <el-table-column prop="st_sign_users_9" label="9月包月续订数" width="150">
						<template slot-scope="scope">
							<div class="td-info">
								<p>{{scope.row.st_sign_users_9}}</p>
							</div>
						</template>
					</el-table-column>
					<el-table-column prop="st_again_sign_money_9" label="9月包月续订金额" width="150">
						<template slot-scope="scope">
							<div class="td-info">
								<p>{{scope.row.st_again_sign_money_9}}</p>
							</div>
						</template>
					</el-table-column>
					<el-table-column prop="st_again_sign_rate_9" label="9月包月续订率" width="150">
						<template slot-scope="scope">
							<div class="td-info">
								<p>{{scope.row.st_again_sign_rate_9}}</p>
							</div>
						</template>
					</el-table-column>
					<el-table-column prop="st_payback_rate_9" label="9月累计回本率" width="150">
						<template slot-scope="scope">
							<div class="td-info">
								<p>{{scope.row.st_payback_rate_9}}</p>
							</div>
						</template>
					</el-table-column>
          <el-table-column prop="st_sign_users_10" label="10月包月续订数" width="150">
						<template slot-scope="scope">
							<div class="td-info">
								<p>{{scope.row.st_sign_users_10}}</p>
							</div>
						</template>
					</el-table-column>
					<el-table-column prop="st_again_sign_money_10" label="10月包月续订金额" width="150">
						<template slot-scope="scope">
							<div class="td-info">
								<p>{{scope.row.st_again_sign_money_10}}</p>
							</div>
						</template>
					</el-table-column>
					<el-table-column prop="st_again_sign_rate_10" label="10月包月续订率" width="150">
						<template slot-scope="scope">
							<div class="td-info">
								<p>{{scope.row.st_again_sign_rate_10}}</p>
							</div>
						</template>
					</el-table-column>
					<el-table-column prop="st_payback_rate_10" label="10月累计回本率" width="150">
						<template slot-scope="scope">
							<div class="td-info">
								<p>{{scope.row.st_payback_rate_10}}</p>
							</div>
						</template>
					</el-table-column>
          <el-table-column prop="st_sign_users_11" label="11月包月续订数" width="150">
						<template slot-scope="scope">
							<div class="td-info">
								<p>{{scope.row.st_sign_users_11}}</p>
							</div>
						</template>
					</el-table-column>
					<el-table-column prop="st_again_sign_money_11" label="11月包月续订金额" width="150">
						<template slot-scope="scope">
							<div class="td-info">
								<p>{{scope.row.st_again_sign_money_11}}</p>
							</div>
						</template>
					</el-table-column>
					<el-table-column prop="st_again_sign_rate_11" label="11月包月续订率" width="150">
						<template slot-scope="scope">
							<div class="td-info">
								<p>{{scope.row.st_again_sign_rate_11}}</p>
							</div>
						</template>
					</el-table-column>
					<el-table-column prop="st_payback_rate_11" label="11月累计回本率" width="150">
						<template slot-scope="scope">
							<div class="td-info">
								<p>{{scope.row.st_payback_rate_11}}</p>
							</div>
						</template>
					</el-table-column>
          <el-table-column prop="st_sign_users_12" label="12月包月续订数" width="150">
						<template slot-scope="scope">
							<div class="td-info">
								<p>{{scope.row.st_sign_users_12}}</p>
							</div>
						</template>
					</el-table-column>
					<el-table-column prop="st_again_sign_money_12" label="12月包月续订金额" width="150">
						<template slot-scope="scope">
							<div class="td-info">
								<p>{{scope.row.st_again_sign_money_12}}</p>
							</div>
						</template>
					</el-table-column>
					<el-table-column prop="st_again_sign_rate_12" label="12月包月续订率" width="150">
						<template slot-scope="scope">
							<div class="td-info">
								<p>{{scope.row.st_again_sign_rate_12}}</p>
							</div>
						</template>
					</el-table-column>
					<el-table-column prop="st_payback_rate_12" label="12月累计回本率" width="150">
						<template slot-scope="scope">
							<div class="td-info">
								<p>{{scope.row.st_payback_rate_12}}</p>
							</div>
						</template>
					</el-table-column>

					<el-table-column label="操作" width="120" fixed="right">
						<template slot-scope="scope">
							<el-button type="primary"  icon="el-icon-edit" size="mini" @click="handleEdit(scope.row)">编辑</el-button>
							<!-- <el-button icon="el-icon-warning-outline" size="mini" @click="handleDetails(scope.row)">详情</el-button> -->
						</template>
					</el-table-column>
				</el-table>
				<div class="foot-table" style="text-align:center;">
					<el-pagination
            @current-change="handleCurrentChange"
            @size-change="handleSizeChange"
            :page-sizes="[20, 50, 100, 200, 500]"
            :page-size="tableData.pageSize"
            background
            :current-page="currentPage"
            layout="sizes, prev, pager, next, jumper, ->, total"
            :total="tableData.totalNum">
					</el-pagination>
				</div>
			</div>

    </div>
		<!--编辑弹框-->
		<el-dialog title="编辑" :visible.sync="dialogFormVisible" width="600px">
			<el-form :rules="rules" ref="ruleForm" :model="ruleForm" label-width="150px" class="input350" size="small" style="max-height: 550px;overflow: auto; padding-right: 20px;">
				<el-form-item label="注册人数：" prop="new_users">
					<el-input type="number" v-model="ruleForm.new_users" placeholder="请输入注册人数" ></el-input>
				</el-form-item>
				<el-form-item label="推广费：" prop="pro_cost">
					<el-input type="number" v-model="ruleForm.pro_cost" placeholder="请输入推广费" ></el-input>
				</el-form-item>
			</el-form>
			<div slot="footer" class="dialog-footer">
				<el-button @click="dialogFormVisible = false">取 消</el-button>
				<el-button type="primary" v-debounce:500="editDialogSureBtn">确 定</el-button>
			</div>
		</el-dialog>

  </div>
</template>
<script>
export default {
  data() {
    return {
      dataTime:[],
      formInline:{},
      currentPage:1,
      loading:false,
      tableData: {
        pageSize: 20,
        pageNo: 1,
        totalPage: 1,
        totalNum: 0,
        result: []
      },
			dialogFormVisible:false,
			ruleForm:{
				id:'',
				new_users:'',
				pro_cost:'',
			},
			rules: {
				new_users: [
					{ required: true, message: '请输入注册人数', trigger: 'blur' }
				],
				pro_cost: [
					{ required: true, message: '请输入推广费', trigger: 'blur' },
				],
			},
    }
  },
  computed: {},
  watch: {
  },
  mounted: function () {
    this.getTableData()
  },
  methods: {
    // 查询
    search() {
      this.currentPage = 1
      this.loading = true
      this.getTableData()
    },

    // 重置
    resetQuery() {
      this.loading = true
      this.$refs['formInline'].resetFields()
      this.dataTime = []
      this.getTableData()
    },
    // pageSize切换
    handleSizeChange (val) {
      this.tableData.pageSize  = val
      this.currentPage = 1
      this.loading = true
      this.getTableData()
    },
    handleCurrentChange(value) {
      this.currentPage = value
      this.loading = true
      this.getTableData()
    },

    // 表格列表
    getTableData(){
      let json2 = {
        pageNo: this.currentPage,
        pageSize: this.tableData.pageSize
      };
      this.formInline.statStartDate = this.dataTime ? this.dataTime[0] : ''
      this.formInline.statEndDate = this.dataTime ? this.dataTime[1] : ''
      let json1 = this.formInline;
      let paramJson = { ...json1, ...json2 };
      this.axios({
        method:'get',
        url:'/novel/data/long/tail',
        params:paramJson
      }).then((response)=>{
       if (response.data.head.flag === 0) {
          this.tableData = response.data.content
          this.loading = false
        } else {
          this.$message.error(response.data.head.desc)
        }
      })
    },

		// 编辑推广费、注册人数
		handleEdit(row){
			console.log(" 编辑推广费、注册人数",row)
			this.ruleForm.id = row.id
			this.ruleForm.new_users = row.new_users
			this.ruleForm.pro_cost = row.pro_cost
			this.dialogFormVisible = true
		},
		//确定提交编辑数据
		editDialogSureBtn(){
			this.$refs['ruleForm'].validate((valid) => {
				if (valid) {
					console.log("编辑数据",this.ruleForm)
					this.axios({
						method:'get',
						url:'/novel/data/long/tail/edit/save',
						params: this.ruleForm
					}).then((response)=>{
					if (response.data.head.flag === 0) {
							this.$message.success("修改成功！")
							this.getTableData()
							this.dialogFormVisible = false
						} else {
							this.$message.error(response.data.head.desc)
						}
					})
				} else {
					console.log('error submit!!');
					return false;
				}
			})
		},


  }
}
</script>
<style lang="scss">
  // .wbdp-long-tail{
  //   /* 自定义滚动条宽度 */
  //   .el-table::-webkit-scrollbar{
  //     width: 4px; /* 设置滚动条的宽度 */
  //   }

  //   /* 滚动条轨道样式 */
  //   .el-table::-webkit-scrollbar-track{
  //     background: #f1f1f1; /* 轨道背景颜色 */
  //   }

  //   /* 滚动条滑块样式 */ 
  //   .el-table::-webkit-scrollbar-thumb {
  //     background: #888; /* 滑块颜色 */
  //     border-radius: 4px; /* 圆角效果 */
  //   }

  //   /* 鼠标悬停时的滑块样式 */
  //   .el-table::-webkit-scrollbar-thumb:hover {
  //     background: #555; /* 悬停时的颜色 */
  //     cursor: pointer;
  //   }
  // }
</style>
